import React from 'react';
import { AudienceProvider } from './components/Audience/AudienceContext';
import Nav from './components/Nav/Nav';
import Hero from './components/Hero/Hero';
import PainStory from './components/PainStory/PainStory';
import Services from './components/Services/Services';
import Process from './components/Process/Process';
import TechStack from './components/TechStack/TechStack';
import Projects from './components/Projects/Projects';
// import Testimonials from './components/Testimonials/Testimonials'; // hidden until real client quotes are ready
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <AudienceProvider>
      <Nav />
      <main id="main-content">
        <Hero />
        <PainStory />
        <Projects />
        <Services />
        <Process />
        {/* <Testimonials /> — hidden until real client quotes are ready */}
        <TechStack />
        <About />
        <Contact />
      </main>
      <Footer />
    </AudienceProvider>
  );
}

export default App;
